import React, { Component } from 'react';
import Header from '../../Layouts/Header'
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import AuthApi from '../../Services/Authapi';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TableComponent from '../../Layouts/TableComponent';
import swal from 'sweetalert';
import TextField from "@material-ui/core/TextField";
import AuthCheckComponent from '../../Layouts/Token';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';

class QulificationList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            qulification: [],
            count: 0,
            pageStatus: false,
            searchQuery: "",
            suggestions: [],
            tableTh: [
                { id: 'qualification', numeric: false, disablePadding: true, label: 'Qualification', sortable: true },
                { id: 'created_at', numeric: false, disablePadding: true, label: 'Created On', sortable: true },
                { id: 'actions', numeric: false, disablePadding: true, label: 'Actions', sortable: false }
            ]
        }
        this.qulificationData = this.qulificationData.bind(this);
        this.removeQulification = this.removeQulification.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.handleSuggestionClick = this.handleSuggestionClick.bind(this);
    }

    componentWillMount() {
        if (this.props && this.props.authToken === false) {
            // this.props.history.push('/login');
        }
        this.qulificationData();
    }

    componentWillReceiveProps(props) {
        if (props && props.authToken === false) {
            // props.history.push('/login');
        }
    }

    qulificationData = async (e) => {
        let qulif = await AuthApi.getQulification();

        if (qulif && qulif.status === true) {
            let sortedData = qulif.data.sort((a, b) => b.id - a.id);
            this.setState({
                qulification: sortedData,
                count: sortedData.length
            })
        }
    }

    async removeQulification(id) {
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: ["Cancel", "Yes"]
        }).then(async (confirm) => {
            if (confirm) {
                try {
                    let currentEvent = await AuthApi.deleteQulification(id);
                    if (currentEvent && currentEvent.status === true) {
                        this.setState({
                            pageStatus: true
                        })
                        this.qulificationData();
                        swal("Success", "Qualification deleted successfully!", "success");
                        setTimeout(
                            () => this.setState({ pageStatus: false }),
                            500
                        );
                    } else {
                        swal("Error", "Failed to delete qualification.", "error");
                    }
                } catch (error) {
                    swal("Error", "Failed to delete qualification.", "error");
                }
            }
        });
    }

    handleChange(e) {
        const searchQuery = e.target.value;
        const suggestions = this.state.qulification.filter((item) => {
            return (
                item.qualification.toLowerCase().includes(searchQuery.toLowerCase())
            );
        });
        this.setState({ searchQuery, suggestions }, this.handleSearch);
    }

    handleSearch = () => {
        // Trigger search functionality
        const filterUser = this.state.qulification.filter((item) => {
            return (
                item.qualification.toLowerCase().includes(this.state.searchQuery.toLowerCase())
            );
        });
        this.setState({ filterUser });
    };

    clearSearch = () => {
        this.setState({ searchQuery: "", suggestions: [] }, this.handleSearch);
    };

    handleSuggestionClick = (suggestion) => {
        this.setState({ searchQuery: suggestion.qualification, suggestions: [] }, this.handleSearch);
    };

    render() {
        const classes = this.props;
        const filterUser = this.state.filterUser || this.state.qulification;
        const permissions = (this.props.authUser && Array.isArray(this.props.authUser.userAccess)) ? this.props.authUser.userAccess : [];
        return (
            <div>
                <AuthCheckComponent authToken={this.props.authToken} />
                <Header
                    {...this.props}
                    authUser={this.props.authUser}
                    setAutUser={this.props.setAutUser}
                    component={
                        <div style={{ marginBottom: "11%" }}>
                            <Card className={classes.root} style={{ marginBottom: '3%' }}>
                                <CardContent>
                                    <Breadcrumb
                                        {...this.props}
                                        primaryPageName="Qualification"
                                        primaryPageLink="/qulification"
                                        isSecondaryPage={false}
                                        secondaryPageName="" />
                                </CardContent>
                            </Card>
                            <TableComponent
                                {...this.props}
                                tableTh={this.state.tableTh}
                                tableData={filterUser}
                                tableCount={filterUser.length}
                                tablePagestatus={this.state.pageStatus}
                                colNameToShow={['qualification', 'created_at']}
                                openPopUp={false}
                                removeRow={this.removeQulification}
                                actionBtns={[permissions.includes("Qualification.Edit") && ('update'), permissions.includes("Qualification.Delete") && ('delete1')]}
                                modelName={'Qualification'}
                                addRoute={'/qulification/add'}
                                updateRoute={'/qulification/edit'}
                                openPopUpUpdate={false}
                                order={'desc'}
                                orderBy={'id'}
                                extraHeaderContent={
                                    <div style={{ position: "relative" }}>
                                        <TextField
                                            label="Search"
                                            value={this.state.searchQuery}
                                            onChange={this.handleChange}
                                            style={{
                                                width: "260px"
                                            }}
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: this.state.searchQuery !== "",
                                                style: {
                                                    color: '#036dda',
                                                    transform: this.state.searchQuery !== "" ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)', // Adjust this line
                                                    transition: 'transform 0.2s ease-in-out'
                                                }
                                            }}
                                            InputProps={{
                                                style: {
                                                    backgroundColor: 'lightgray',
                                                    borderRadius: '25px',
                                                    height: "40px"
                                                },
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {this.state.searchQuery && (
                                                            <ClearIcon onClick={this.clearSearch} style={{ cursor: 'pointer' }} />
                                                        )}
                                                        <SearchIcon onClick={this.handleSearch} style={{ cursor: 'pointer' }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        {this.state.searchQuery && this.state.suggestions.length > 0 && (
                                            <Paper
                                                style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: 0,
                                                    marginTop: '4px',
                                                    zIndex: 2,
                                                    width: "100%",
                                                    maxHeight: '200px',
                                                    overflowY: 'auto',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '4px',
                                                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
                                                }}>
                                                {this.state.suggestions.map((suggestion, index) => (
                                                    <MenuItem
                                                        key={index}
                                                        onClick={() => this.handleSuggestionClick(suggestion)}
                                                        style={{
                                                            padding: '10px 20px',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        {suggestion.qualification}
                                                    </MenuItem>
                                                ))}
                                            </Paper>
                                        )}
                                    </div>
                                }
                            />
                        </div>
                    } />
                <Footer {...this.props} />
            </div >
        )
    }
}

export default QulificationList;
